import React, { memo } from "react";
import { useHistory } from 'react-router-dom';
import { Col, Row } from "react-bootstrap";
import {  faMapMarkerAlt,
          faPhoneAlt,
          faFax,
          faEnvelope } from '@fortawesome/free-solid-svg-icons';
import {  faYoutube,
          faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import img_epa from "../../assets/images/partners/footer/epa.png";
import img_idrc from "../../assets/images/partners/footer/idrc.png";
import img_ipcc from "../../assets/images/partners/footer/ipcc.png";
import img_unfccc from "../../assets/images/partners/footer/unfccc.png";
import img_harvard from "../../assets/images/partners/footer/harvard.png";

import "./footer.css";

function Footer() {
  const idrc_url = "https://idrc.ca";
  const epa_url = "https://epa.gov";
  const harvard_url = "https://www.harvard.edu/";
  const ipcc_url = "https://ipcc.ch";
  const unfccc_url = "https://unfccc.int";

  const join_network_url = "https://arca-alexandria.maps.arcgis.com/apps/GeoForm/index.html?appid=0ecceb24dcb146c1980755a7c65ca86f";
  const network_map = "http://arca-alexandria.maps.arcgis.com/apps/SummaryViewer/index.html?appid=e27f7c001fe64fdabd9795c0b95691ec";
  const search_for_colleagues = "http://arca-alexandria.maps.arcgis.com/apps/InteractiveFilter/index.html?appid=6f6d37a2aef84436898f8bc6d3f1d08e";
  
  const youtube_url = "https://www.youtube.com/@arcaalexandria5116";
  const linkedin_url = "https://www.linkedin.com/in/arca-alexandria-831b45270";

  const history = useHistory();

  const routeChange = (path) => {
    history.push(path);
  }

  return (
    <>
    <div className="footer">
      <div className="footer-container">
        <h3 className="footer-title text-center">Partners</h3>
        <Row className="footer-row">
          <Col>
            <a href={idrc_url} target="_blank" rel="noreferrer" title="IDRC — International Development Research Centre">
              <img className="footer-img" src={img_idrc} alt="IDRC" />
            </a>
            <a href={epa_url} target="_blank" rel="noreferrer" title="EPA — Enivornmental Protection Agency">
              <img className="footer-img" src={img_epa} alt="EPA" />
            </a>
          </Col>
        </Row>
        <Row className="footer-row">
          <Col>
            <a href={harvard_url} target="_blank" rel="noreferrer" title="Harvard University">
              <img className="footer-img" src={img_harvard} alt="Harvard Logo" />
            </a>
            <a href={ipcc_url} target="_blank" rel="noreferrer" title="IPCC — The Intergovernmental Panel on Climate Change">
              <img className="footer-img" src={img_ipcc} alt="IPCC" />
            </a>
          </Col>
        </Row>
        <Row className="footer-row">
          <Col>
            <a href={unfccc_url} target="_blank" rel="noreferrer" title="UNFCCC — United Nations Framework Convention on Climate Change">
              <img className="footer-img" src={img_unfccc} alt="" />
            </a>
          </Col>
        </Row>
      </div>

      <div className="footer-container">
        <h3 className="footer-title text-center">Network</h3>
          <a href={join_network_url} target="_blank" rel="noreferrer">Join ARCA's network</a>
          <a href={network_map} target="_blank" rel="noreferrer">ARCA's network map</a>
          <a href={search_for_colleagues} target="_blank" rel="noreferrer">Search for colleagues</a>
      </div>

      <div className="footer-container">
        <h3 className="footer-title text-center">Social</h3>
        <Row className="footer-row">
          <Col>
            <a href={youtube_url} target="_blank" rel="noreferrer" className="footer-link-icon" title="ARCA's Youtube Channel">
              <FontAwesomeIcon icon={faYoutube} />
            </a>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <a href={linkedin_url} target="_blank" rel="noreferrer" className="footer-link-icon" title="ARCA's LinkedIn page">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
          </Col>
        </Row>
      </div>
      
      <div className="footer-container">
        <h3 className="footer-title text-center">Contact Us</h3>
        <table className="footer-table">
          <tbody>
            <tr>
              <td className="pb-3">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
              </td>
              <td className="pb-3">
                <a href="https://maps.app.goo.gl/v6GyuvqC79ErcKgz6" target="_blank" rel="noreferrer">
                  <button>163 Horreya Avenue, El-Shatby, Alexandria, Egypt</button>
                </a>
              </td>
            </tr>
            <tr>
              <td className="pb-3">
                <FontAwesomeIcon icon={faPhoneAlt} />
              </td>
              <td className="pb-3">
                <a href="tel: +20 34249290">
                  +20 34249290
                </a>
              </td>
            </tr>
            <tr>
              <td className="pb-3">
                <FontAwesomeIcon icon={faFax} />
              </td>
              <td className="pb-3">
                <a href="tel: +20 34249290">
                  +20 34249290
                </a>
              </td>
            </tr>
            <tr>
              <td className="pb-3">
                <FontAwesomeIcon icon={faEnvelope} />
              </td>
              <td className="pb-3">
                <button onClick={() => routeChange('contact-us')} >
                  <p>
                    Contact our team
                  </p>
                </button>
              </td>
            </tr>              
          </tbody>
        </table>
      </div>
    </div >
    <span className="footer-signature">© {new Date().getFullYear()} ARCA – All rights reserved</span>
    </>
  );
}

export default memo(Footer);